<template>
  <div class="left-menu">
    <!-- <div class="left-menu-gap">
      <div class="left-menu-gap-block"></div>
    </div> -->
    <div class="left-menu-normal" :class="{ active: !fixed }">
      <div class="menu-name" @click.stop="goHomePage">
        <el-image
          v-if="isPlanet"
          class="menu-name-logo planet"
          src="https://image.renrenjiang.cn/jy_star/icons/admin_icon/icon_jystar_logo.png?t=11"
        ></el-image>
        <el-image
          v-else
          class="menu-name-logo"
          src="https://image.renrenjiang.cn/jy_star/icons/admin_icon/icon_logo.png"
        ></el-image>
        <!-- <div class="name-text">店铺</div> -->
        <!-- <div @click="changeFixed" class="fix-btn">
          <div class="fix-btn-icon"></div>
        </div> -->
      </div>
      <!-- <div class="menu-divider"></div> -->
      <!-- <el-image
        @click="pageToLiveScen"
        class="icon_dashboard_left_guide"
        src="https://image.renrenjiang.cn/domain_tools/icons/icon_dashboard_left_guide.png"
      ></el-image> -->
      <div class="menu-list">
        <div v-for="(n, i) in modules" class="menu-item" v-bind:key="i">
          <div
            @click="clickParent(n)"
            class="menu-item-parent"
            :class="{
              active:
                (!n.children || (n.children && n.children.length === 0)) &&
                n.path.startsWith(frame),
            }"
          >
            <div class="parent-name">
              <div
                class="parent-name-icon"
                :style="{
                  backgroundImage:
                    'url(https://image.renrenjiang.cn/jy_star/icons/admin_icon/icon_menu_new_' +
                    n.icon +
                    '.png?t=12345)',
                }"
              ></div>
              <div class="parent-name-text">{{ n.title }}</div>
            </div>
            <div
              v-if="n.children && n.children.length > 0"
              class="parent-arrow"
              :class="{ collapse: !n.collapse }"
            ></div>
          </div>
          <div
            v-if="n.children && n.children.length > 0"
            class="menu-item-children"
            :class="{ uncollapse: !n.collapse }"
            :style="{ height: Math.ceil(n.children.length / 2) * 36 + 'px' }"
          >
            <div
              v-for="(y, x) in n.children"
              @click="clickChild(y)"
              v-bind:key="x"
              class="child-item"
              :class="{ active: y.path && frame.startsWith(y.path) }"
            >
              {{ y.title }}
            </div>
          </div>
        </div>
        <div class="menu-list-gap"></div>
      </div>
      <!-- <div class="menu-customer">
        <div class="menu-customer-btn">
          <el-image
            class="menu-customer-icon"
            src="https://image.renrenjiang.cn/domain_tools/icons/icon_leftmenu_customer_service.png"
          ></el-image>
          <div class="menu-customer-text" @click="pageToChat">客服工作台</div>
        </div>
      </div> -->
      <div class="left-menu-arrow">
        <div class="left-menu-arrow-shadow"></div>
        <div @click="changeFixed" class="left-menu-arrow-bg">
          <el-image
            class="left-menu-arrow-icon"
            src="https://image.renrenjiang.cn/domain_tools/icons/icon_menu_left_arrow_icon.png"
          ></el-image>
        </div>
      </div>
    </div>
    <div class="left-menu-fixed" :class="{ active: fixed }">
      <!-- <div @click="changeFixed" class="unfix-btn">
        <div class="unfix-btn-icon"></div>
      </div> -->
      <el-image
        class="menu-mini-logo"
        src="https://image.renrenjiang.cn/domain_tools/icons/icon_logo_test1_mini.png"
      ></el-image>
      <div class="menu-mini-list">
        <div v-for="(n, i) in modules" v-bind:key="i" class="menu-mini-item">
          <el-popover placement="right-start" trigger="hover">
            <div
              slot="reference"
              class="mini-item-icon"
              :style="{
                backgroundImage:
                  'url(https://image.renrenjiang.cn/jy_star/icons/admin_icon/icon_menu_new_' +
                  n.icon +
                  '.png?t=12345)',
              }"
            ></div>
            <div
              class="menu-popover"
              :class="{ padding0: !n.children || n.children.length === 0 }"
            >
              <div class="menu-parent-name">{{ n.title }}</div>
              <div class="menu-popover-children">
                <div
                  v-for="(b, a) in n.children"
                  v-bind:key="a"
                  @click="clickChild(b)"
                  class="child-item"
                  :class="{
                    active: b.path.startsWith(frame),
                  }"
                >
                  {{ b.title }}
                </div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <!-- <div class="mini-customer-btn">
        <el-image
          class="mini-customer-icon"
          src="https://image.renrenjiang.cn/domain_tools/icons/icon_leftmenu_customer_service.png"
        ></el-image>
      </div> -->
      <div class="left-menu-arrow">
        <div class="left-menu-arrow-shadow"></div>
        <div @click="changeFixed" class="left-menu-arrow-bg">
          <el-image
            class="left-menu-arrow-icon opposite"
            src="https://image.renrenjiang.cn/domain_tools/icons/icon_menu_left_arrow_icon.png"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { modules } from "./modules";
import { getSwitch } from "@/api/user";
// import { modules2 } from "./modules2";
// import { getUserDetail } from "@/api/setting";
// import { asyncRouterMap } from "@/router";

export default {
  data() {
    return {
      isPlanet: false,
      fixed: false,
      frame: "",
      // modules: modules,
      // modules: [],
      guideDialog: {
        visible: false,
      },
      focusStep: 0,
      playBool: false,
      current: null,
      showLiveGuide: false,
      showPointer: true,
      // 微信支付开户菜单显隐（sub_merchant 开关）
      subMerchantEnabled: false,
      // 公众号授权菜单显隐（live_manage 开关）
      liveManageEnabled: false,
    };
  },
  computed: {
    modules() {
      console.log("this.$route", this.$route.path);
      // if (this.$route.path.startsWith("/p/")) {
      //   if (child_id) {
      //     // let _module = this.$rrj.storage.get("_module");
      //     // console.log(_module, "_module");
      //     // const result = [modules2[0]];
      //     // _module = _module.filter((val) => val.title !== "首页");

      //     // if (Array.isArray(_module) && _module.length > 0) {
      //     //   _module.forEach((module) => {
      //     //     modules2.forEach((val) => {
      //     //       if (module.path === val.path) {
      //     //         console.log(
      //     //           module.path,
      //     //           val.path,
      //     //           "_module.children",
      //     //           _module.children
      //     //         );
      //     //         if (module.children && module.children.length > 0) {
      //     //           const children = [];
      //     //           module.children.forEach((child) => {
      //     //             const idx = val.children.findIndex(
      //     //               (vChild) => vChild.path === child.path
      //     //             );
      //     //             if (idx !== -1) {
      //     //               // val.children[idx].meta.title = child.title;
      //     //               children.push(val.children[idx]);
      //     //             } else {
      //     //               console.log("child.name", child.name);
      //     //             }
      //     //           });
      //     //           console.log(children, "childern");
      //     //           result.push({
      //     //             ...val,
      //     //             // meta: { title: module.title, icon: module.icon },
      //     //             children: Array.from(new Set(children)),
      //     //           });
      //     //         }
      //     //       }
      //     //     });
      //     //   });
      //     // }
      //     // console.log(result, "result");
      //     // return result;
      //     // return modules2;
      //   } else {
      //     // return modules2;
      //   }
      // } else {
      let _module = this.$rrj.storage.get("_module");
      console.log(_module, "_module");
      console.log(modules, "modules");
      // modules[0]
      const result = [];
      // _module = _module.filter((val) => val.title !== "首页");

      if (Array.isArray(_module) && _module.length > 0) {
        _module.forEach((module) => {
          modules.forEach((val) => {
            if (module.path === val.path) {
              console.log(
                module.path,
                val.path,
                "_module.children",
                _module.children
              );
              if (module.children && module.children.length > 0) {
                const children = [];
                module.children.forEach((child) => {
                  const idx = val.children.findIndex(
                    (vChild) => vChild.path === child.path
                  );
                  if (idx !== -1) {
                    // val.children[idx].meta.title = child.title;
                    children.push(val.children[idx]);
                  } else {
                    console.log("child.name", child.name);
                  }
                });
                if (module.path === "/live") {
                  const liveManagedPaths = [
                    "/live/siyu",
                    "/live/wechat-authorizer",
                    "/live/domain",
                  ];
                  if (this.liveManageEnabled) {
                    liveManagedPaths.forEach((path) => {
                      const route = val.children.find(
                        (vChild) => vChild.path === path
                      );
                      const has = children.some((item) => item.path === path);
                      if (route && !has) {
                        children.push(route);
                      }
                    });
                  } else {
                    for (let i = children.length - 1; i >= 0; i--) {
                      if (liveManagedPaths.includes(children[i].path)) {
                        children.splice(i, 1);
                      }
                    }
                  }
                }
                if (module.path === "/setting") {
                  const serviceSubscriptionRoute = val.children.find(
                    (vChild) => vChild.path === "/setting/serviceSubscription"
                  );
                  const hasServiceSubscription = children.some(
                    (item) => item.path === "/setting/serviceSubscription"
                  );
                  if (serviceSubscriptionRoute && !hasServiceSubscription) {
                    children.push(serviceSubscriptionRoute);
                  }
                  // 微信支付开户（sub_merchant 开关控制）
                  if (this.subMerchantEnabled) {
                    const wechatPayRoute = val.children.find(
                      (vChild) => vChild.path === "/accounting/wechat-pay/apply"
                    );
                    const hasWechatPay = children.some(
                      (item) => item.path === "/accounting/wechat-pay/apply"
                    );
                    if (wechatPayRoute && !hasWechatPay) {
                      children.push(wechatPayRoute);
                    }
                  }
                }
                console.log(children, "childern");
                result.push({
                  ...val,
                  // meta: { title: module.title, icon: module.icon },
                  children: Array.from(new Set(children)),
                });
              } else {
                result.push(val);
              }
            }
          });
        });
      }

      console.log(result, "result");
      // result[2].children.push({
      //   path: "/order/manage",
      //   title: "抖店订单",
      //   component: () => import("@/views/order/manage"),
      //   name: "orderManage",
      //   meta: { title: "抖店订单" },
      // });
      return result;
      // }
    },
    ...mapGetters(["permission_routers", "sidebar"]),
    // routes() {
    //   return this.$router.options.routes;
    // },
    // isCollapse() {
    //   return true;
    //   // return !this.sidebar.opened;
    // },
    // key() {
    //   console.log(this.$router);
    //   return this.$route.name;
    // },
  },
  components: {
    // WhaleDialog,
  },
  watch: {
    frame: {
      handler: function (val) {
        console.log(val, "val");
        let arr = this.modules.filter((item) => {
          return item.path && item.path.startsWith(val);
        });
        if (arr.length > 0) {
          for (let item of arr) {
            if (!item.children || item.children.length === 0 || item.pid > 0) {
              item.active = true;
            }
          }
        }
        console.log("frame", val, arr);
        console.log(
          this.frame,
          this.frame != "dashboard" || this.frame != "group/list",
          "1312"
        );
        // if (this.frame.includes("quick") || this.frame.includes("shop/live")) {
        //   this.guideDialog.visible = false;
        // }
      },
      deep: true,
    },
    $route: {
      handler: function (val) {
        console.log(val.fullPath, "val.fullPath========");
        // this.frame = val.fullPath.substring(1);
        this.frame = val.fullPath;
        console.log(this.isPlanet, "this.isPlanet====");
        if (val.fullPath.startsWith("/p/")) {
          document.title = "星球会员";
          if (!this.isPlanet) {
            this.getIcon(true);
          }
        } else {
          document.title = "人人讲精品课";
          if (this.isPlanet) {
            this.getIcon(false);
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$route.path.startsWith("/p/")) {
      this.isPlanet = true;
      document.title = "星球会员";
      this.getIcon(true);
    } else {
      this.isPlanet = false;
      document.title = "人人讲精品课";
      this.getIcon(false);
    }
    // let sqls = [];
    // let id = 1,
    //   sortNum = 0;
    // for (let item of this.modules) {
    //   let sql =
    //     `insert into assist_module(id, pid, path, src, icon, name, title, created_at, updated_at, status, sort_num) ` +
    //     `values(${id}, 0, null, null, '${item.icon}', null, '${
    //       item.name
    //     }', now(), now(), 1, ${sortNum++});`;
    //   console.log(sql);
    //   sqls.push(sql);
    //   let childId = 1,
    //     childSort = 0;
    //   for (let child of item.children) {
    //     let childsql =
    //       `insert into assist_module(id, pid, path, src, icon, name, title, created_at, updated_at, status, sort_num) ` +
    //       `values(${id * 10 + childId++}, ${id}, '${child.url}', '${
    //         child.url
    //       }', null, '${child.route}', '${
    //         child.name
    //       }', now(), now(), 1, ${childSort++});`;
    //     console.log(childsql);
    //     sqls.push(childsql);
    //   }
    //   id++;
    // }
    // console.log(sqls.join(" "));
    // console.log(this.permission_routers, "permission_routers");
  },
  async created() {
    const _ukit = this.$rrj.storage.get("_ukit");
    console.log(_ukit, "----");
    await this.allModuleList(_ukit.id);
    if (_ukit && _ukit.id) {
      this.fetchSubMerchantSwitch(_ukit.id);
      this.fetchLiveManageSwitch(_ukit.id);
    }
    this.frame = this.$route.fullPath;
    // this.frame = this.$route.fullPath.substring(1);
    // let guideRecord = this.$rrj.storage.get("_guide");
    // if (!guideRecord) this.openMask();

    this.$root.$on("leftMenuFixed", (bool) => {
      console.log(bool, "leftMenuFixed");
      this.fixed = bool;
      this.$emit("fixed", this.fixed);
    });

    this.$root.$on("openQuick", () => {
      console.log("openQuickopenQuickopenQuick");
      this.guideDialog.visible = true;
    });

    this.$bus.$on("openSliderFix", () => {
      this.fixed = false;
      this.$emit("fixed", this.fixed);
    });
  },
  methods: {
    getIcon(bool) {
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      if (bool) {
        link.href = "https://www.xingqiuhuiyuan.com/favicon.ico";
      } else {
        link.href = "https://dy.renrenjiang.cn/favicon.ico";
      }
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    mouseenter(i) {
      console.log(i);
      this.current = i;
      this.showPointer = false;
      // this.playBool = true;
      try {
        setTimeout(() => {
          if (i === 4) {
            this.$refs["video" + i] && this.$refs["video" + i].play();
          } else {
            this.$refs["video" + i] &&
              this.$refs["video" + i][0] &&
              this.$refs["video" + i][0].play();
          }
          // console.log(this.$refs["video" + i]);
        }, 300);
      } catch (error) {
        console.log(error);
      }
    },
    mouseleave() {
      this.current = null;
      // this.playBool = false;
      // try {
      //   setTimeout(() => {
      //     // this.$refs["video" + i] && this.$refs["video" + i].pause();
      //   }, 150);
      // } catch (error) {
      //   console.log(error);
      // }
    },
    async fetchSubMerchantSwitch(userId) {
      try {
        const res = await getSwitch({
          user_id: userId,
          include: "sub_merchant",
        });
        this.subMerchantEnabled = res.sub_merchant === "1";
      } catch (e) {
        this.subMerchantEnabled = false;
      }
    },
    async fetchLiveManageSwitch(userId) {
      try {
        const res = await getSwitch({
          user_id: userId,
          include: "live_manage",
        });
        this.liveManageEnabled = res.live_manage === "1";
      } catch (e) {
        this.liveManageEnabled = false;
      }
    },
    async allModuleList() {
      // console.log(getUserDetail, id);
      // const res = await getUserDetail({ userId: id });
      // if (res && res.code === 200) {
      //   this.modules = res.data.modules.map((element) => {
      //     return {
      //       ...element,
      //       collapse: true,
      //     };
      //   });
      console.log("modules", this.modules);
      // }
    },
    closeMask() {
      this.guideDialog.visible = false;
      this.$bus.$emit("closeMask");
      this.$rrj.storage.set("_guide", true, 24 * 3600);
    },
    openMask() {
      this.guideDialog.visible = true;
    },
    pageToChat() {
      this.$router.push("/chat");
    },
    clickChild(item) {
      if (item.title === "内容管理") {
        const token = this.$rrj.storage.get("_token");
        return window.open(
          "https://www.xingqiuhuiyuan.com/#/index?access_token=" + token.id,
          "_blank"
        );
      } else if (item.title === "星球会员") {
        const token = this.$rrj.storage.get("_token");
        return window.open(
          "https://www.xingqiuhuiyuan.com/admin/#/p/dashboard?access_token=" +
            token.id,
          "_blank"
        );
      } else {
        this.$router.push({ path: item.path });
      }

      // this.$router.push({ path: item.path });
      // .catch(() => true);
    },
    clickParent(item) {
      if (item.children && item.children.length > 0) {
        item.collapse = !item.collapse;
      } else {
        item.active = true;

        console.log(item, "----");

        // if (item.title === "内容管理") {
        //   const token = this.$rrj.storage.get("_token");
        //   return window.open(
        //     "https://www.xingqiuhuiyuan.com/#/index?planetId=" +
        //       this.planetId +
        //       "&access_token=" +
        //       token.id,
        //     "_blank"
        //   );
        // } else {
        this.$router.push({ path: item.path });
        // }

        // .catch(() => true);
      }

      this.$forceUpdate();
    },
    changeFixed() {
      this.fixed = !this.fixed;
      this.$emit("fixed", this.fixed);
    },
    pageToUrl(url) {
      if (url === "/shop/live/url") {
        this.showLiveGuide = true;
        return;
      }

      this.showLiveGuide = false;

      let routeData = this.$router.resolve({
        path: url,
      });
      window.open(routeData.href, "_blank");
    },
    pageToLiveScen() {
      this.$router.push({ path: "/quick/live" });
    },
    goHomePage() {
      if (this.isPlanet) {
        this.$router.push("/p/dashboard");
      } else {
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style lang="scss">
// .newer-mask {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 100000;
//   background-color: rgba(0, 0, 0, 0.4);

//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;

//   .newer-btns {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     margin-top: 30px;

//     .newer-btn {
//       margin: 0 10px;
//       background-color: transparent;
//       border-color: #ffffff;
//     }
//   }

//   .newer-block {
//     width: 1218px;
//     height: 679px;
//     border-radius: 20px;
//     background-color: #ffffff;
//     overflow: hidden;

//     display: flex;
//     align-items: center;

//     .newer-block-left {
//       position: relative;
//       width: 0;
//       height: 100%;
//       flex-grow: 1;

//       .left-bg {
//         position: absolute;
//         top: 42px;
//         left: 0;

//         width: 39px;
//         height: 51px;
//         background-size: 100% 100%;
//         background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_newer_bg.png);
//       }

//       .left-title {
//         position: absolute;
//         top: 60px;
//         left: 50px;

//         line-height: 44px;
//         font-weight: 600;
//         font-size: 28px;
//         color: #090909;
//       }

//       .step-block {
//         position: absolute;
//         top: 194px;
//         left: 50px;

//         .step-bg {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 288px;
//           height: 84px;
//           border-radius: 10px;
//           transition: all 0.2s;
//           background: linear-gradient(156deg, #0ba2ff 22%, #0366ff 69%);
//         }

//         .step-list {
//           position: absolute;
//           top: 0;
//           left: 0;
//           z-index: 10;

//           .step-item {
//             width: 288px;
//             height: 94px;
//             cursor: pointer;
//             margin-bottom: 10px;

//             display: flex;
//             align-items: center;

//             padding: 20px 10px;
//             box-sizing: border-box;

//             &.focus {
//               .step-item-num {
//                 color: #ffffff;
//               }

//               .step-item-info {
//                 .step-item-name {
//                   color: #ffffff;
//                 }

//                 .step-item-tips {
//                   color: rgba($color: #ffffff, $alpha: 0.6);
//                 }
//               }
//             }

//             .step-item-num {
//               width: 55px;
//               line-height: 44px;
//               font-weight: 700;
//               font-size: 36px;
//               color: #090909;
//               transition: all 0.2s;
//             }

//             .step-item-info {
//               .step-item-name {
//                 line-height: 24px;
//                 font-size: 16px;
//                 font-weight: 600;
//                 color: #090909;
//                 transition: all 0.2s;
//               }

//               .step-item-tips {
//                 margin-top: 8px;
//                 line-height: 22px;
//                 font-size: 14px;
//                 color: #acacac;
//                 transition: all 0.2s;
//               }
//             }
//           }
//         }
//       }
//     }

//     .newer-block-right {
//       width: 820px;
//       height: 100%;
//       background: linear-gradient(209deg, #eff5ff 1%, #dbe8ff 79%);

//       display: flex;
//       align-items: center;
//       justify-content: center;

//       .right-video {
//         width: 780px;
//         height: 518px;
//         background-size: 100% 100%;
//         background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_newer_videobg.png);

//         display: flex;
//         align-items: center;
//         justify-content: center;

//         .video-player {
//           width: 700px;
//           height: 4348px;
//         }
//       }
//     }
//   }
// }
.icon_dashboard_left_guide {
  margin-left: 10px;
  margin-bottom: 10px;
  width: 220px;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
}

.newer-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.4);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .newer-block {
    width: 1065px;
    height: 650px;
    border-radius: 20px;
    background-color: #f4fbff;
    overflow: hidden;

    .dialog-head-close {
      margin: 20px 20px 0 0;
      float: right;
      width: 20px;
      height: 20px;
      cursor: pointer;
      background-position: 0 0;
      background-size: 40px 20px;
      background-image: url(https://image.renrenjiang.cn/teacher_center/website/icon_normal_close_tt.png);
      text-align: end;

      &:hover {
        background-position: -20px 0;
      }
    }

    .newer-block-top {
      margin-top: 40px;
      text-align: center;
      width: 1065px;
      height: 44px;
      font-size: 36px;
      font-weight: 600;
      color: #090909;
      line-height: 44px;
    }

    .newer-block-center {
      cursor: pointer;
      font-size: 16px;
      color: #0366ff;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .newer-block-bottom {
      position: relative;
      margin-top: 35px;
      width: 1065px;
      height: 487px;
      display: flex;
      justify-content: space-around;
      padding-left: 60px;
      padding-right: 60px;
      box-sizing: border-box;

      .newer-block-pointer {
        position: absolute;
        left: 130px;
        opacity: 0;
        bottom: 200px;
        width: 50px;
        height: 50px;
        z-index: 1000;
        animation: animatePointer 0.8s 0.6s forwards;
      }

      .bottom-video {
        display: flex;
        flex-direction: column;
        align-items: center;

        .video-centent {
          position: relative;
          width: 165px;
          height: 357px;
          border-radius: 12px;
          cursor: pointer;
          box-shadow: 0px 4px 20px 0px rgba(109, 145, 196, 0.4);

          video {
            width: 100%;
            height: 100%;
            border-radius: 12px;
          }

          .live_tag {
            position: absolute;
            z-index: 1000;
            top: -24px;
            left: -10px;
          }
        }

        .video-text {
          padding-top: 25px;
          // width: 80px;
          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: #090909;
          line-height: 28px;
          text-align: center;

          .el-image {
            width: 12px;
            height: 12px;
          }
        }

        .video-live-text {
          color: #ed343b;
        }

        .video-button {
          margin-top: 15px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 88px;
          height: 32px;
          border-radius: 4px;
          box-sizing: border-box;
          border: 1px solid #0366ff;
          font-size: 14px;
          color: #2d80ff;
          cursor: pointer;
        }

        .video-live-button {
          background: #ed343b;
          border: 1px solid #ed343b;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
}

.left-menu {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 200;

  .left-menu-gap {
    width: 100%;
    height: 100px;
    overflow: hidden;

    .left-menu-gap-block {
      width: 100%;
      height: 60px;
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    }
  }

  .left-menu-normal {
    position: relative;

    // position: absolute;
    top: 0;
    left: 0;
    width: 240px;
    height: 100%;
    background-color: #ffffff;
    // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.04);
    box-shadow: 2px 0px 6px 0px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
    transform: translateX(calc(-100% - 24px));

    display: flex;
    flex-direction: column;

    &.active {
      transform: translateX(0);
      transition-delay: 0.2s;
    }
  }

  .left-menu-fixed {
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 2px 0px 6px 0px rgba(0, 0, 0, 0.1);
    transition: all 0.2s;
    transform: translateX(calc(-100% - 24px));

    display: flex;
    flex-direction: column;
    align-items: center;

    &.active {
      transform: translateX(0);
      transition-delay: 0.3s;
    }
  }
}

.menu-mini-logo {
  width: 32px;
  height: 32px;
  margin-top: 25px;
}

.unfix-btn {
  width: 40px;
  height: 40px;
  margin: 8px auto;
  border-radius: 4px;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f7fa;

    .unfix-btn-icon {
      opacity: 1;
    }
  }

  .unfix-btn-icon {
    width: 20px;
    height: 20px;
    opacity: 0.4;
    background-position: 0 0;
    background-size: 40px 20px;
    background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_menubar_fixed.png);
  }
}

.fix-btn {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f5f7fa;

    .fix-btn-icon {
      opacity: 1;
    }
  }

  .fix-btn-icon {
    width: 18px;
    height: 18px;
    opacity: 0.4;
    background-position: 0 0;
    background-size: 36px 18px;
    background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_menubar_unfixed.png);
  }
}

.menu-name {
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  color: #1f2026;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
  font-weight: 600;
  padding: 20px 0 20px 14px;
  box-sizing: border-box;
  cursor: pointer;

  .menu-name-logo {
    width: 112px;
    height: 36px;

    &.planet {
      width: 131px;
      height: 29px;
    }
  }
}

.menu-divider {
  width: 212px;
  margin: 0 auto;
  border-bottom: 1px solid #f2f3f7;
}

.menu-customer {
  padding: 10px 25px;
  box-sizing: border-box;
  box-shadow: 0px -2px 6px 0px rgba(0, 0, 0, 0.1);

  .menu-customer-btn {
    width: 190px;
    height: 40px;
    border-radius: 4px;
    background-color: #0366ff;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #3585ff;
    }

    &:active {
      background-color: #035ce6;
    }

    .menu-customer-icon {
      width: 20px;
      height: 20px;
    }

    .menu-customer-text {
      margin-left: 10px;
      line-height: 20px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

.menu-list {
  width: 100%;
  height: 0;
  flex-grow: 1;
  overflow: auto;

  .menu-list-gap {
    height: 100px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    background-color: transparent;
    border-radius: 0;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .menu-item {
    width: 100%;
    padding: 0 10px 8px;
    box-sizing: border-box;
    position: relative;

    .menu-item-parent {
      display: flex;
      align-items: center;
      justify-content: space-between;

      color: #23242b;
      cursor: pointer;

      height: 40px;
      padding: 0 8px;
      border-radius: 4px;
      box-sizing: border-box;

      font-size: 14px;

      &.active {
        background-color: #f0f6ff !important;
        color: #0366ff;

        .parent-name {
          .parent-name-icon {
            background-position: 0 0;
          }
        }
      }

      &:hover {
        background-color: #f5f7fa;
      }

      .parent-name {
        display: inline-flex;
        align-items: center;

        .parent-name-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          background-position: 20px 0;
          background-size: 40px 20px;
        }
      }

      .parent-arrow {
        width: 24px;
        height: 24px;
        background-size: 14px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_menu_arrow.png);
        transition: all 0.3s;

        &.collapse {
          transform: rotate(-180deg);
        }
      }
    }

    .menu-item-children {
      margin-bottom: 4px;
      padding-left: 40px;
      box-sizing: border-box;

      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      transition: all 0.3s;

      &.uncollapse {
        height: 0 !important;
      }

      .child-item {
        width: 86px;
        height: 36px;
        // margin-left: 16px;

        line-height: 36px;
        color: #8a8c99;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;

        display: flex;
        align-items: center;

        &.active {
          font-weight: 600;
          color: #0366ff;
        }

        &:hover {
          color: #0366ff;
        }
      }
    }
  }
}

.mini-customer-btn {
  width: 40px;
  height: 40px;
  margin: 15px 0;
  border-radius: 4px;
  background-color: #0366ff;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #3585ff;
  }

  &:active {
    background-color: #035ce6;
  }

  .mini-customer-icon {
    width: 20px;
    height: 20px;
  }
}

.menu-mini-list {
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 0;
  flex-grow: 1;
  overflow: auto;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    background-color: transparent;
    border-radius: 0;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .menu-mini-item {
    width: 40px;
    height: 40px;
    margin: 8px auto;
    border-radius: 4px;
    cursor: pointer;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: #f5f7fa;

      .mini-item-icon {
        opacity: 1;
      }

      .mini-item-icon {
        background-position: 0 0;
      }
    }

    .mini-item-icon {
      width: 24px;
      height: 24px;
      // opacity: 0.4;
      background-position: 24px 0;
      background-size: 48px 24px;
      background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_menubar_fixed.png);
    }
  }
}

.left-menu-normal,
.left-menu-fixed {
  &:hover {
    .left-menu-arrow {
      opacity: 1;
      // transform: translateX(48px);
    }
  }
}

.left-menu-arrow {
  position: absolute;
  top: 50%;
  right: -48px;

  opacity: 0;
  width: 48px;
  // transform: translateX(0px);
  transition: all 0.15s;

  .left-menu-arrow-shadow {
    position: absolute;
    top: 10px;
    left: 0;

    width: 24px;
    height: 60px;
    box-shadow: 5px 0px 6px 0px rgba(0, 0, 0, 0.1);
  }

  .left-menu-arrow-bg {
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    width: 24px;
    height: 80px;
    background-size: 24px 80px;
    background-image: url(https://image.renrenjiang.cn/domain_tools/icons/icon_menu_left_arrow.png);

    display: flex;
    align-items: center;
    justify-content: center;

    .left-menu-arrow-icon {
      width: 20px;
      height: 20px;

      &.opposite {
        transform: rotate(180deg);
      }
    }
  }
}

.live-guide-box {
  width: 570px;
  height: 446px;
  border-radius: 20px;

  background: #ffffff;

  .live-guide-box-item {
    display: flex;
    justify-content: space-between;
    width: 500px;
    height: 154px;
    box-sizing: border-box;
    margin: 0 auto 15px;
    padding: 10px 20px;
    border-radius: 10px;
    background: #f7f8fa;
  }

  .live-guide-box-item-img {
    width: 68px;
    height: 134px;
  }

  .live-guide-box-title {
    padding-top: 22px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #090909;
  }

  .live-guide-box-desc {
    font-size: 14px;
    line-height: 22px;
    color: #acacac;
    padding-top: 5px;
    padding-bottom: 15px;
  }

  .live-guide-box-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 66px;
    height: 24px;
    color: #0366ff;
    border-radius: 212px;
    box-sizing: border-box;
    border: 1px solid #0366ff;
  }

  .dialog-head-close {
    margin: 20px 20px 0 0;
    float: right;
    width: 20px;
    height: 20px;
    cursor: pointer;
    background-position: 0 0;
    background-size: 40px 20px;
    background-image: url(https://image.renrenjiang.cn/teacher_center/website/icon_normal_close_tt.png);
    text-align: end;

    &:hover {
      background-position: -20px 0;
    }
  }

  .live-guide-box-head {
    padding-left: 35px;
    height: 88px;
    font-size: 20px;
    font-weight: 600;
    line-height: 88px;
    color: #090909;
  }
}

@keyframes animatePointer {
  0% {
    opacity: 0;
    left: 230px;
    bottom: 60px;
  }

  100% {
    opacity: 1;
    left: 130px;
    bottom: 200px;
  }
}

.menu-popover {
  padding: 6px 0;

  &.padding0 {
    padding: 0;
  }

  .menu-parent-name {
    width: 100%;
    height: 40px;
    padding: 0 20px;
    box-sizing: border-box;

    line-height: 40px;
    font-weight: 600;
    font-size: 14px;
    color: #1f2026;
  }

  .menu-popover-children {
    max-height: 280px;
    overflow: auto;

    .child-item {
      width: 100%;
      height: 40px;
      padding: 0 20px;
      box-sizing: border-box;

      line-height: 40px;
      font-size: 14px;
      color: #626573;
      cursor: pointer;

      &:hover {
        color: #0366ff;
      }

      &.active {
        font-weight: 600;
        color: #0366ff;
      }
    }
  }
}
</style>
